export default "/hotbox/content/frontend/release/static/misc/manifest-vkp.webmanifest";